module.exports = __webpack_public_path__ + "static/media/projector_projection_screen.6a042a96.svg";